(function () {
  function initSection(sectionEl) {
    var accordion = sectionEl.querySelector('[data-ia-accordion]');
    var imagesWrap = sectionEl.querySelector('[data-ia-images]');
    if (!accordion || !imagesWrap) return;

    var hoverMode = accordion.getAttribute('data-ia-hover') === 'true';
    var items = Array.from(accordion.querySelectorAll('[data-ia-item]'));
    var imageSlides = Array.from(imagesWrap.querySelectorAll('[data-ia-image]'));

    function showImage(index) {
      imageSlides.forEach(function (slide) {
        var slideIndex = parseInt(slide.getAttribute('data-ia-image'), 10);
        if (slideIndex === index) {
          slide.classList.add('is-active');
        } else {
          slide.classList.remove('is-active');
        }
      });
    }

    function openItem(item) {
      var body = item.querySelector('[data-ia-body]');
      var trigger = item.querySelector('[data-ia-trigger]');
      item.classList.add('is-active');
      if (body) body.style.maxHeight = body.scrollHeight + 'px';
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      showImage(parseInt(item.getAttribute('data-ia-item'), 10));
    }

    function closeItem(item) {
      var body = item.querySelector('[data-ia-body]');
      var trigger = item.querySelector('[data-ia-trigger]');
      item.classList.remove('is-active');
      if (body) body.style.maxHeight = '0';
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    function activateItem(item) {
      items.forEach(function (i) {
        if (i !== item) closeItem(i);
      });
      openItem(item);
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-ia-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        if (item.classList.contains('is-active')) {
          closeItem(item);
        } else {
          activateItem(item);
        }
      });

      if (hoverMode) {
        item.addEventListener('mouseenter', function () {
          if (!item.classList.contains('is-active')) {
            activateItem(item);
          }
        });
      }
    });

    if (items.length > 0) {
      openItem(items[0]);
    }
  }

  function init() {
    var sections = document.querySelectorAll('[data-ia-section]');
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var wrap = e.target.querySelector('[data-ia-section]');
    if (wrap) initSection(wrap);
  });
})();
